// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"ed0b263f","724":"43d77b51"}[chunkId] + ".chunk.js";
};